import { Box, Heading } from "@chakra-ui/react"
import { DepositForAccount } from "@mezo/api"

import {
  RootState,
  selectCurrentLockForDeposit,
  selectModalOptions,
  useDappSelector,
} from "#/redux-state"
import { useDepositMigrationModalForm } from "#/shared/hooks/deposit-migration"
import DepositCarouselModalHeader from "#/ui-old/DepositCarousel/DepositCarouselModalHeader"

import DepositMigrationButton from "./DepositMigrationButton"
import DepositMigrationCarousel from "./DepositMigrationCarousel"
import DepositMigrationInfo from "./DepositMigrationInfo"
import DepositMigrationNotAvailable from "./DepositMigrationNotAvailable"

// 31 October 2024 23:59:59 GMT
const MIGRATION_BLOCK_PERIOD_DATE = new Date(1730419199 * 1000)

type DepositMigrationModalBaseProps = {
  deposits: DepositForAccount[]
  selectedDeposit?: DepositForAccount
  onDepositCarouselChange: (previousIndex: number, nextIndex: number) => void
  onSuccessfulMigration: () => void
}

export default function DepositMigrationModalBase({
  deposits,
  selectedDeposit,
  onDepositCarouselChange,
  onSuccessfulMigration,
}: DepositMigrationModalBaseProps) {
  const { migrationStatus, migrateDeposit } =
    useDepositMigrationModalForm(selectedDeposit)

  const { initialActiveDepositUuid } = useDappSelector(selectModalOptions)

  const currentLock = useDappSelector((state: RootState) =>
    selectCurrentLockForDeposit(state, selectedDeposit),
  )

  const allowMigration =
    currentLock && selectedDeposit
      ? new Date(`${currentLock.lockEnd} GMT`) > MIGRATION_BLOCK_PERIOD_DATE
      : true

  return (
    <Box bg="primary.white.100" borderRadius="1.5rem" w="522px">
      <DepositCarouselModalHeader bg="linear-gradient(0deg, #D4EBEB 0%, #D4EBEB 100%), #FFF;">
        <Heading variant="h3" fontSize="32px" lineHeight="40px">
          Migrate WBTC to tBTC
        </Heading>
      </DepositCarouselModalHeader>
      <form
        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
          e.preventDefault()
          migrateDeposit(onSuccessfulMigration)
        }}
      >
        <DepositMigrationCarousel
          deposits={deposits}
          initialDepositUuid={initialActiveDepositUuid}
          onItemChange={onDepositCarouselChange}
          mt="40px"
          mb="8px"
        />
        {allowMigration ? (
          <DepositMigrationButton
            migrationStatus={migrationStatus}
            selectedDeposit={selectedDeposit}
          />
        ) : (
          <Box px="46px" pb="32px">
            {selectedDeposit && (
              <DepositMigrationNotAvailable selectedDeposit={selectedDeposit} />
            )}
          </Box>
        )}
      </form>
      <Box px="46px" pb="32px">
        <DepositMigrationInfo />
      </Box>
    </Box>
  )
}
